export default __webpack_public_path__ + "static/media/hero-level-4-bg.74c895ed.webp";